import { useEffect } from 'react';
import './App.css';
import { MantineProvider } from '@mantine/core';
import { PageLayout } from './ui/Layout/PageLayout';
import { useFurnitureStore } from './stores/FurnitureStore'
import { NotificationsProvider } from '@mantine/notifications';

function App() {
  const { getCategories } = useFurnitureStore();

  useEffect(() => {
    getCategories()
  }, [])

  return (
    <MantineProvider
      theme={{
        primaryColor: 'teal',
        defaultRadius: 'sm',
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
        headings: { fontFamily: "ui-serif, Georgia, 'Times New Roman', serif" },
      }}
      withGlobalStyles
      withNormalizeCSS
    >
      <NotificationsProvider>
        <PageLayout />
      </NotificationsProvider>
    </MantineProvider>
  );
}
export default App;
